import { render } from "./speed.vue?vue&type=template&id=ebb55096"
import script from "@/views/bot-manager/speed.ts?vue&type=script&lang=js&external"
export * from "@/views/bot-manager/speed.ts?vue&type=script&lang=js&external"

import "./speed.vue?vue&type=style&index=0&id=ebb55096&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.17_vue@3.5.17_typescript@4.9.5__webpack@5.89.0_@swc+core@1.12.7_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/bot-manager/speed.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ebb55096"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ebb55096', __exports__)) {
    api.reload('ebb55096', __exports__)
  }
  
  module.hot.accept("./speed.vue?vue&type=template&id=ebb55096", () => {
    api.rerender('ebb55096', render)
  })

}


export default __exports__